module.exports = __webpack_public_path__ + "img/linkedin.b625465c.svg";